import React from "react"
import { useDispatch } from "react-redux"
import { resetBasket } from "../../redux/actions/basket-actions"
import { resetJourney } from "../../redux/actions/journey-actions"
import "./reset-page.scss"

export const ResetPage = () => {
  const dispatch = useDispatch()

  const handleReset = () => {
    // Dispatch action to redux to reset store
    dispatch(resetBasket())
    // Reset to the first page in the journey by dispatching the firstPage action
    dispatch(resetJourney())
  }

  return (
    <div className="reset-page-container">
      <h1>End of Experiment</h1>
      <p>
        You&apos;ve now reached the end of the experiment. Normally a bespoke
        respondent survey would follow to capture details about the customer.
      </p>
      <div className="back-button-container">
        <button className="back-button" onClick={handleReset}>
          Reset Experiment
        </button>
      </div>
    </div>
  )
}
